<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-10-19 10:52:34
 * @LastEditors: Jianyong Wang
 * @LastEditTime: 2021-11-02 09:42:22
-->
<template>
  <a-select
    ref="selectRef"
    v-model:value="formDataItem.value"
    class="tag-select"
    size="large"
    mode="multiple"
    :rules="formDataItem.rules"
    :placeholder="formDataItem.placeholder"
    :aria-readonly="true"
    :open="false"
    dropdown-class-name="placeholder-mutiple-select-dropdown"
    @focus="handleFocus"
  >
    <a-select-option
      v-for="opt in formDataItem.data"
      :key="opt[replaceFields.value]"
      :value="opt[replaceFields.value]"
    >
      <a-tooltip
        v-if="opt[replaceFields.label] && opt[replaceFields.label].length > 10"
        :title="opt[replaceFields.label]"
      >
        <tag
          :tag-length="0"
          :color="opt.color"
          is-delete
          @delete="formDataItem.delete(opt[replaceFields.value])"
        >
          {{ `${opt[replaceFields.label].slice(0, 10)}...` }}
        </tag>
      </a-tooltip>
      <tag
        v-else
        :tag-length="0"
        :color="opt.color"
        is-delete
        @delete="formDataItem.delete(opt.value)"
      >
        {{ `${opt.label}` }}
      </tag>
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import Tag from '../Tag/index.vue'

export default defineComponent({
  components: {
    Tag
  },
  props: {
    formDataItem: {
      type: Object,
      default: () => {}
    },
    replaceFields: {
      type: Object,
      default: () => ({
        label: 'label',
        value: 'value'
      })
    }
  },
  emits: ['focus'],
  setup(props, context) {
    const selectRef = ref()

    const handleFocus = () => {
      context.emit('focus')

      selectRef.value.blur()
    }

    return {
      handleFocus,
      selectRef
    }
  }
})
</script>
